import React from 'react';
import Button from '@mui/material/Button';
import { Typography } from '@mui/material';
import PropTypes from 'prop-types';
import FormButtonGroup from '../components/layout/FormButtonGroup.jsx';

export default function PrivacyPolicy({ handleScreenNext, handleScreenBack }) {
  return (
    <React.Fragment>
      <Typography variant="body2" color="primary">
        Mindanao State University- Iligan Institute of Technology is committed to maintaining the
        accuracy, confidentiality, integrity and security of your personal information. As part of
        this commitment, our privacy policy governs our actions as they relate to the collection,
        use, disclosure and disposal of Personal Information as implemented by the Data Privacy Act
        of 2012 or otherwise known as Republic Act 10173.
      </Typography>
      <FormButtonGroup>
        <React.Fragment>
          <Button variant="contained" size="large" color="error" onClick={() => handleScreenBack()}>
            Decline
          </Button>
          <Button
            variant="contained"
            size="large"
            color="primary"
            onClick={() => handleScreenNext()}
          >
            Accept
          </Button>
        </React.Fragment>
      </FormButtonGroup>
    </React.Fragment>
  );
}

PrivacyPolicy.propTypes = {
  handleScreenNext: PropTypes.func,
  handleScreenBack: PropTypes.func,
};
